import { DocumentsService } from 'services';
import React, { useEffect, useMemo, useState } from 'react'
import { Tabs } from 'components/navigation';
import { ShowHide } from 'components/layout';
import { AreaStorage } from 'pages/account/edit/storage/area-storage';
import { LocationStorage } from 'pages/account/edit/storage/location-storage';
import { MonthlyStorage } from 'pages/account/edit/storage/monthly-storage/MonthlyStorage';

export function Storage() {
    const [loading, setLoading] = useState(true);

    const [storageBreakdown, setStorageBreakdown] = useState({
        areaStats: [],
        locationStats: [],
        otherLocationsStats: null,
        monthlyStats: []
    });

    const areaTabKey = 'AREA_STORAGE';
    const locationTabKey = 'LOCATION_STORAGE';
    const monthlyUsageTabKey = 'MONTHLY_USAGE';

    const [selectedTabKey, setSelectedTabKey] = useState(areaTabKey);

    const onTabClick = (tabIndex) => {
        setSelectedTabKey(tabs[tabIndex].key);
    };

    const tabs = useMemo(() => [
        { title: 'Areas', key: areaTabKey, selected: selectedTabKey === areaTabKey },
        { title: 'Locations', key: locationTabKey, selected: selectedTabKey === locationTabKey },
        { title: 'Monthly Usage', key: monthlyUsageTabKey, selected: selectedTabKey === monthlyUsageTabKey }
    ], [selectedTabKey]);

    useEffect(() => {
        DocumentsService.getStorageBreakdown().then(b => {
            setStorageBreakdown(b);
            setLoading(false);
        })
    }, []);

    return <div className='row'>
        <div>
            <h2>Storage</h2>
        </div>
        <Tabs tabs={tabs} onClick={onTabClick} loading={loading} />
        <ShowHide
            evaluator={selectedTabKey === areaTabKey}
            show={(
                <AreaStorage areaStorage={storageBreakdown.areaStats} loading={loading} />
            )}
        />
        <ShowHide
            evaluator={selectedTabKey === locationTabKey}
            show={(
                <LocationStorage locationStorage={storageBreakdown.locationStats} otherLocationStorage={storageBreakdown.otherLocationsStats} loading={loading} />
            )}
        />
        <ShowHide
            evaluator={selectedTabKey === monthlyUsageTabKey}
            show={(
                <MonthlyStorage monthlyStorageData={storageBreakdown.monthlyStats} loading={loading} />
            )}
        />        
    </div>
}